import { useEffect, useState } from 'react';
import styles from './Banner.module.scss';
import RightArrow from '../../assets/icons/right_arrow.png';
import LeftArrow from '../../assets/icons/left_arrow.png';
import { motion, AnimatePresence } from 'framer-motion';

interface IBannerProps {
    itemsToRender: Array<string>;
    customBannerContainerStyle?: string;
    customBannerStyle?: string;
}
export default function Banner({
    itemsToRender,
    customBannerContainerStyle,
    customBannerStyle,
}: IBannerProps) {
    const [selectedItem, setSelectedBanner] = useState<string>(itemsToRender[0]);
    const [count, setCount] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            if (count > itemsToRender.length - 1) {
                setCount(0);
                return;
            }
            setCount((prev) => prev + 1);

            setSelectedBanner(itemsToRender[count]);
        }, 2000);

        return () => clearInterval(interval);
    });

    const handlePreviousBanner = () => {
        const prevCount = Math.max(count - 1, 0);
        setCount(prevCount);
        setSelectedBanner(itemsToRender[prevCount]);
    };

    const handleNextBanner = () => {
        const nextCount = Math.min(count + 1, itemsToRender.length - 1);
        setSelectedBanner(itemsToRender[nextCount]);
    };

    return (
        <div className={`${styles.bannerContainer} ${customBannerContainerStyle}`}>
            <section className={`${styles.banner} ${customBannerStyle}`}>
                <AnimatePresence mode="popLayout">
                    <motion.img
                        key={selectedItem}
                        src={selectedItem}
                        alt="Banner"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 1.05 }}
                        transition={{ duration: 0.6 }}
                        className={styles.banner_image}
                    />
                </AnimatePresence>

                <img
                    src={LeftArrow}
                    alt="right arrow"
                    className={styles.left_nav}
                    onClick={handlePreviousBanner}
                />
                <img
                    src={RightArrow}
                    alt="right arrow"
                    className={styles.right_nav}
                    onClick={handleNextBanner}
                />
            </section>
        </div>
    );
}
